export default __webpack_public_path__ + "static/media/EM0410.34I-22011_-15121_0.64fc135d.jpg";